import { Plus, Phone } from "lucide-react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { FAQS, BUSINESS } from "@/data/site";
import { SectionHeader, Reveal } from "@/components/motion/Reveal";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 bg-ink2/60">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16">
      <div className="lg:col-span-4">
        <SectionHeader id="faq" eyebrow="Straight answers" lines={["Questions", <>we get <span className="text-brand-light">asked.</span></>]} />
        <Reveal delay={0.2} className="hidden lg:block bg-panel/80 border border-white/10 rounded-xl p-7">
          <div className="eyebrow mb-2">Still unsure?</div>
          <p className="text-slate-400 text-sm leading-relaxed mb-5">Rickie's happy to have a yarn about your job, no pressure (pun intended).</p>
          <a href={`tel:${BUSINESS.phoneRaw}`} className="btn-primary w-full !text-base" data-testid="faq-call-btn">
            <Phone size={16} strokeWidth={2.5} /> {BUSINESS.phone}
          </a>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <AccordionPrimitive.Root type="single" collapsible className="border-t border-white/10" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <Reveal key={f.q} delay={i * 0.05} y={20}>
              <AccordionPrimitive.Item value={`faq-${i}`} className="border-b border-white/10 group" data-testid={`faq-item-${i + 1}`}>
                <AccordionPrimitive.Header>
                  <AccordionPrimitive.Trigger
                    className="w-full flex items-start justify-between gap-6 py-6 sm:py-7 text-left group/trigger [&[data-state=open]_.plus]:rotate-45 [&[data-state=open]_.plus]:bg-brand [&[data-state=open]_.plus]:text-white [&[data-state=open]_.q]:text-brand-light"
                    data-testid={`faq-trigger-${i + 1}`}
                  >
                    <span className="flex gap-5 sm:gap-8">
                      <span className="font-mono text-xs text-slate-500 pt-1.5 tabular-nums">0{i + 1}</span>
                      <span className="q font-display font-extrabold uppercase tracking-tight text-xl sm:text-2xl text-white transition-colors duration-300 group-hover/trigger:text-brand-light">{f.q}</span>
                    </span>
                    <span className="plus shrink-0 grid place-items-center w-9 h-9 rounded-full border border-white/15 text-white transition-[transform,background-color,color] duration-300">
                      <Plus size={16} strokeWidth={2.5} />
                    </span>
                  </AccordionPrimitive.Trigger>
                </AccordionPrimitive.Header>
                <AccordionPrimitive.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
                  <p className="pb-7 pl-[3.1rem] sm:pl-[4.1rem] pr-4 text-slate-400 leading-relaxed text-sm sm:text-base max-w-2xl" data-testid={`faq-answer-${i + 1}`}>
                    {f.a}
                  </p>
                </AccordionPrimitive.Content>
              </AccordionPrimitive.Item>
            </Reveal>
          ))}
        </AccordionPrimitive.Root>
      </div>
    </div>
  </section>
);
